import React, { useState, useEffect } from "react";
import "./SupportiveNavMainPage.scss";
import { Link } from "react-router-dom";

const SupportiveNavMainPage = ({ data, oneBannersData }) => {
  // State variable to track page size
  const [isMobileView, setIsMobileView] = useState(window.innerWidth < 775);

  // Update isMobileView when the window size changes
  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth < 775);
    };

    // Add event listener to handle window resize
    window.addEventListener("resize", handleResize);

    // Remove event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // Determine which object to display based on page size
  const backgroundImage = isMobileView
    ? oneBannersData[1]?.src || ""
    : oneBannersData[0]?.src || "";

  const backgroundStyle = {
    backgroundImage: `url(${backgroundImage})`,
  };

  return (
    <Link
      to={oneBannersData[0]?.url}
      className="support_services__">

      <img src={oneBannersData[0]?.src} alt={"banner"}/>
    </Link>
  );
};

export default SupportiveNavMainPage;
